/**
 * Stop propagation handler
 * @param {Event} e - The event object
 */
const stopPropagationHandler = (e) => {
    e.stopPropagation();
};

export default stopPropagationHandler;